<template>
    <div>
        Vlogs
    </div>
</template>

<script>
    export default {
        name: "vlogs"
    }
</script>

<style scoped>

</style>